<template>
  <div class="d-flex align-items-center">
    <img
      width="28"
      height="28"
      :src="option?.userDetail?.photo || $getInitials(option?.name)"
      style="border-radius: 50%"
      class="mr-2"
    />
    <p class="mb-0">
      {{ option?.name }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'UserOptionTemplate',
  props: {
    option: null,
  },
}
</script>
